export const useViteEnvironment = () => {
  const isDev = import.meta.env.VITE_ENV === 'development'
  const isProd = import.meta.env.VITE_ENV === 'production'
  const isTest = import.meta.env.VITE_ENV === 'test'
  const isDemo = import.meta.env.VITE_ENV === 'demo'

  return {
    isDev,
    isProd,
    isTest,
    isDemo,
  }
}